import { jsx as _jsx } from "react/jsx-runtime";
import { Toggle, ToggleControlled } from '@kubit/web-ui-components/toggle';
import { POSITIONS } from '@kubit/web-ui-components/types/positions';
import { ToggleWrapperStyled } from '../../selectorRow.styled';
export const SelectorRowToogle = ({ variant, selected, disabled = false, toggleUncontrolled = true, onToggleChange, toggleConfig, }) => {
    const togglePosition = selected ? POSITIONS.RIGHT : POSITIONS.LEFT;
    if (toggleUncontrolled) {
        return (_jsx(ToggleWrapperStyled, { children: _jsx(Toggle, { defaultTogglePosition: togglePosition, disabled: disabled, variant: variant, ...toggleConfig }) }));
    }
    return (_jsx(ToggleWrapperStyled, { children: _jsx(ToggleControlled, { disabled: disabled, togglePosition: togglePosition, variant: variant, onChange: () => onToggleChange?.(!selected), ...toggleConfig }) }));
};
//# sourceMappingURL=selectorRowToggle.js.map